import '../../../styles/_OTPInput.scss';
// @ vendors
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// @ commons
import { formatText, FormattedText } from 'core/i18n';
// @ utilities
import classNames from 'classnames';
import { InputText } from 'components/inputText/inputText';
// @ actions
const formActions = require('react-redux-form').actions;

class OtpBlock extends Component {
    buildOTPLoading = () => {
        return (
            <div className="joint-holder__otp-reload">
                <span className="icons--icon-otp-loading" />
            </div>
        );
    };

    buildErrorOTP = (isValidOTP, wasOTPValidated, handleTaggingBuildOtpInput) => {
        if (!isValidOTP && wasOTPValidated) {
            handleTaggingBuildOtpInput();
            return (
                <div>
                    <p className="form__field_error">
                        <FormattedText value="validation-otpInvalid" />
                    </p>
                </div>
            );
        }
    };

    buildOTPInput = () => {
        const {
            userProfile,
            userProfileForm,
            formActions,
            isValidOTP,
            handleTaggingBuildOtpInput,
            otpModel,
            handleTaggingOnClick,
            wasOTPValidated,
        } = this.props;
        const iconClass = classNames({ 'icons--icon-check': isValidOTP }, { hidden: !isValidOTP });

        return (
            <div className="otp-block__robo-content">
                <div className="form__input">
                    <label className="top-label">
                        <FormattedText value="otp-confirmationCode" />
                    </label>
                    <br />
                    <label className="sub-label">
                        <FormattedText value="otp-enterCode" />
                    </label>
                </div>
                <div className="promo-code__input row">
                    <div className="col-xs-9 col-sm-6" onClick={() => handleTaggingOnClick()}>
                        <InputText
                            profileModel={otpModel}
                            id="otpCode"
                            type="text"
                            messagesError={{
                                valid: formatText('validation-otpInvalid'),
                                obsolete: formatText('validation-otpObsolete'),
                            }}
                            userProfile={userProfile}
                            formActions={formActions}
                            userProfileForm={userProfileForm}
                            onChange={this.handleOtpValidation}
                        />
                        {this.buildErrorOTP(isValidOTP, wasOTPValidated, handleTaggingBuildOtpInput)}
                    </div>
                    <div className="col-xs-2 col-sm-2">
                        <span className={iconClass} />
                    </div>
                </div>
                <p className="prospects-disclaimer">
                    <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP1" />
                    <a
                        className="otp-block__link"
                        href="#"
                        onClick={event => {
                            event.preventDefault();
                            this.handleReloadOTPCode();
                        }}
                    >
                        <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP2" />
                    </a>
                    <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP3" />
                </p>
            </div>
        );
    };

    buildOTPSucces = () => {
        return (
            <div className="otp-block__robo-success">
                <div className="icon-block">
                    <span className="icons--icon-check" />
                </div>
                <div className="title">
                    <label className="top-label">
                        <FormattedText value="otp-registeredSignature" />
                    </label>
                </div>
            </div>
        );
    };

    handleOtpValidation = event => {
        const { validateOTP, autoValidate } = this.props;
        if (event.target.value.length === 4 && autoValidate) {
            validateOTP(event.target.value);
        }
    };

    handleReloadOTPCode = () => {
        const { reloadOtp } = this.props;
        reloadOtp();
    };

    render() {
        const { loadingOTP, className, otpSuccess } = this.props;
        const buildOTP = otpSuccess
            ? this.buildOTPSucces()
            : loadingOTP
            ? this.buildOTPLoading()
            : this.buildOTPInput();
        return <div className={className}>{buildOTP}</div>;
    }
}

OtpBlock.propTypes = {
    className: PropTypes.string,
    validateOTP: PropTypes.func,
    reloadOtp: PropTypes.func,
    autoValidate: PropTypes.bool,
    isValidOTP: PropTypes.bool.isRequired,
    loadingOTP: PropTypes.bool.isRequired,
    handleTaggingBuildOtpInput: PropTypes.func,
    otpModel: PropTypes.string.isRequired,
    handleTaggingOnClick: PropTypes.func,
    otpSuccess: PropTypes.bool,
};

OtpBlock.defaultProps = {
    className: '',
    autoValidate: false,
    handleTaggingBuildOtpInput: () => {},
    handleTaggingOnClick: () => {},
    otpModel: '',
    otpSuccess: false,
};

module.exports.constructor = OtpBlock;
module.exports.OtpBlock = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
    })
)(OtpBlock);
